const PRODUCT_HEADER = 'x-product';
const EXPERIENCE_ID_HEADER = 'x-experience-id';
export const CLOUD_ID_HEADER = 'x-cloudid';

const JIRA_PRODUCT = 'jira';
const CSM_AI_EXPERIENCE_ID = 'csm-ai';

export function createHeaders(init?: HeadersInit): Headers {
	return new Headers({
		[PRODUCT_HEADER]: JIRA_PRODUCT,
		[EXPERIENCE_ID_HEADER]: CSM_AI_EXPERIENCE_ID,
		...(init || {}),
	});
}

export function getRequestHeadersForAnnotation(cloudId?: string) {
	const headers = createHeaders({
		...(cloudId
			? {
					[CLOUD_ID_HEADER]: cloudId,
				}
			: {}),
		'Content-Type': 'application/json',
	});
	return headers;
}
